// extracted by mini-css-extract-plugin
export default {"modalPaper":"style_modalPaper__5rL6T","modalActions":"style_modalActions__vbSu9","modalContent":"style_modalContent__ejHKc"};